import React from 'react'

import { Cylinder } from '../../geometries/Cylinder'
import { Cube } from '../../geometries/Cube'
import { TextItem } from '../TextItem'

import { getTableTextWidth } from './Table'
import { getContrastColor } from 'sections/options/sections/RestaurantDesigner/helpers'

export const CircleTable = ({ position, color, width = 60, caption }) => {
	return (
		<group position={position} scale={[1, 1, 1]} rotation={[0, 0, 0]} castShadow receiveShadow>
			<Cube color={color} position={[width / -4, 20, width / 4]} size={[5, 40, 5]} />
			<Cube color={color} position={[width / 4, 20, width / 4]} size={[5, 40, 5]} />
			<Cube color={color} position={[width / -4, 20, width / -4]} size={[5, 40, 5]} />
			<Cube color={color} position={[width / 4, 20, width / -4]} size={[5, 40, 5]} />
			<Cylinder color={color} position={[0, 40, 0]} size={[width / 2, width / 2, 2.5, 50]} />
			{caption && 
				<TextItem
					key={`${caption}_caption`}
					width={25}
					height={5}
					rotation={0}
					text={caption}
					position={[getTableTextWidth(caption), 38, -7]}
					color={getContrastColor(color)}
					hideShadow
				/>
			}
		</group>
	)
}
